import { render, staticRenderFns } from "./TeamRunnitSettings.vue?vue&type=template&id=44347de3"
import script from "./TeamRunnitSettings.vue?vue&type=script&lang=ts"
export * from "./TeamRunnitSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports